import React from "react";
import * as S from "./styled";
interface Props {
  children: React.ReactNode;
}

export function HeroLayout({ children }: Props) {
  return (
    <S.Wrapper>
      <S.HeroContent>{children}</S.HeroContent>
    </S.Wrapper>
  );
}
